<div class="formgrid grid mr-2">
    <div class="col-6 font-bold">
        <app-input-text [disabled]="!selectedProject || !isProjectOwnershipValid" [label]="'Project Name'" [useIcon]="true" [useTitle]="true" [id]="'nameInput'"
            [model]="selectedProject?.name" [isValid]="isProjectNameValid" [isValueDuplicated]="isProjectNameDuplicated" [isValueDuplicatedMessage]="'This project name already exists'" [isRequired]="true"
            (onChangeEvent)="projectNameChanged($event)"></app-input-text>
    </div>
    <div class="col-6 mt-2 font-bold">
        <app-input-textarea [disabled]="!selectedProject || !isProjectOwnershipValid" [label]="'Project Description'" [useTitle]="true" class="w-10"
            [id]="'descriptionInput'" [autoResize]="false" [rows]="1" [model]="selectedProject?.description"
            (onChangeEvent)="projectDescriptionChanged($event)"></app-input-textarea>
    </div>
</div>

<div class="formgrid grid mt-2 mr-2">
    <div class="col-3 font-bold">
        <app-auto-complete
            [hardDisabled]="!selectedProject || !isProjectOwnershipValid"
            [isValid]="isFormulationValid"
            [label]="'Formulation'"
            [id]="'nameInput'"
            [placeholder]="'Start typing to search'"
            [isRequired]="true"
            [forceSelection]="true"
            [showClear]="true"
            [optionLabel]="'tradeName'"
            [suggestions]="filteredFormulations"
            [model]="selectedFormulation"
            (queryFilterEvent)="onQueryFilterEvent($event)"
            (selectionChangedEvent)="formulationSelectionChanged($event)"
            (onClearEvent)="formulationOnClear($event)"
            (onDropdownClickEvent)="formulationDropdownClicked($event)" >
        </app-auto-complete>
    </div>
    <div class="col-3 font-bold">
        <app-dropdown
          class="w-10"
          [hardDisabled]="!selectedProject || !isProjectOwnershipValid"
          [id]="'nameInput'"
          [isRequired]="true"
          [isValid]="isGeographyValid"
          [label]="'Geography'"
          [loading]="loadingGeographies"
          [model]="selectedGeography"
          [optionLabel]="'name'"
          [options]="geographies"
          [placeholder]="'Select a Geography'"
          [showClear]="true"
          [useTitle]="true"
          (onChangeEvent)="geographySelectionChanged($event)"
        />
    </div>

    <div class="col-6 font-bold" style="width: 40%;">
        <app-input-text [label]="'Created by'" [useTitle]="true" class="w-10" [id]="'descriptionInput'"
            [disabled]="true" [model]="createdBy"></app-input-text>
    </div>
</div>
